export const types = {
    SET_ERROR: 'SET_ERROR',
    CLEAR_ERROR: 'CLEAR_ERROR',
    SET_SOCKET_ERROR: 'SET_SOCKET_ERROR',
};

export interface ISetError {
    errorHeader: string;
    errorBody: string;
}
